import { UseQueryOptions, useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { reportError } from 'utils/error'
import qs from 'qs'

interface Props extends Filters {}

interface Filters {
  width?: number
  height?: number
  element_type?: 'Template' | 'Element'
  type?: string[]
  style?: string[]
  category?: string[]
  query?: string
}

type Data = Record<string, number>

export const useVisualElementsCounts = (
  { width, height, element_type, type, style, category, query }: Props,
  options?: Partial<UseQueryOptions<Data>>,
) => {
  const queryKey = ['visualElementsCounts', { width, height, element_type, type, style, category, query }]

  const fetchCounts = async (params: string) => {
    const res = await sendToApi<Data>(`/visual_elements/counts?${params}`)
    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      throw new Error()
    }

    return res.data
  }

  return useQuery<Data>(
    queryKey,
    ({ pageParam = 1, queryKey: [_, filters] }) => {
      const { width, height, element_type, type, style, category, query } = filters as Filters
      const params = qs.stringify(
        {
          width,
          height,
          page: pageParam,
          element_type,
          type,
          style,
          category,
          query,
        },
        { arrayFormat: 'brackets' },
      )
      return fetchCounts(params)
    },
    {
      ...options,
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
    },
  )
}
